import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './Filter.styles';

export default function Filter(props) {
  return <Styled.Container>{props.children}</Styled.Container>;
}

Filter.propTypes = {
  children: PropTypes.node,
  filterTable: PropTypes.func,
};
